import { ToastProvider } from '@antoree/ant-ui';
import { LanguageProvider, NotificationProvider, UserProvider } from 'contexts';
import { FC } from 'react';
import { ChatUnreadProvider } from 'contexts/ChatUnreadContext';
import { ScreenRecorderProvider } from 'contexts/ScreenRecorderContext';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

import GlobalSocketListener from 'components/GlobalSocketListener';
import { NotificationToast } from 'components/Notification';

const AppProvider: FC<{}> = ({ children }) => (
  <LanguageProvider>
    <HelmetProvider context={{}}>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <ChatUnreadProvider>
            <ScreenRecorderProvider>
              <NotificationProvider>{children}</NotificationProvider>
            </ScreenRecorderProvider>
          </ChatUnreadProvider>
        </UserProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
      <ToastProvider />
    </HelmetProvider>
  </LanguageProvider>
);

export default AppProvider;
